import React from 'react';

import healthCare from '@assets/industries/health-care.png';
import logistics from '@assets/industries/logistics.png';
import finance from '@assets/industries/finance.png';
import commerce from '@assets/industries/commerce.png';
import retail from '@assets/industries/retail.png';
import teleCommunication from '@assets/industries/tele-communication.png';
import government from '@assets/industries/government.png';
import publicSector from '@assets/industries/public-sector.png';
import energy from '@assets/industries/energy.png';
import marketing from '@assets/industries/marketing.png';
import manufacturing from '@assets/industries/manufacturing.png';
import { SalariesData } from '@lib/constants';
import Image from 'next/image';

function Opportunities({ subTitle, isWeb3Course = false }) {
  const cardList = [
    {
      // point: '10 LPA',
      point: SalariesData.averageSalary,
      subPoint: 'Average Annual Base Salary',
      logo: '/assets/salary.png',
    },

    {
      point: 'Most In-demand Skill',
      subPoint: 'in 2024',
      logo: '/assets/growth.png',
    },

    {
      point: '28%',
      subPoint: 'Annual Job Growth by 2026',
      logo: '/assets/growth-chart.png',
    },
  ];

  const industriesList = [
    { logo: healthCare, point: 'Healthcare' },
    { logo: logistics, point: 'Logistics' },
    { logo: finance, point: 'Fintech' },
    { logo: commerce, point: 'E-commerce' },
    { logo: retail, point: 'Retail' },
    { logo: teleCommunication, point: 'Telecommunications' },
    { logo: government, point: 'Government' },
    { logo: publicSector, point: 'Public Sector' },
    { logo: energy, point: 'Energy' },
    { logo: marketing, point: 'Marketing' },
    { logo: manufacturing, point: 'Manufacturing' },
  ];

  const inDemandRoleBulletPointDataScience = [
    {
      bulletColor: '#9654E5',
      point: 'Data Scientist',
    },

    {
      bulletColor: '#4B2CE7',
      point: 'Data Analyst',
    },

    {
      bulletColor: '#FF6676',
      point: 'Data Engineer',
    },

    {
      bulletColor: '#FF8800',
      point: 'ML Engineer',
    },
  ];

  const inDemandRoleBulletPointWebDev = [
    {
      bulletColor: '#9654E5',
      point: 'Solution Architect',
    },

    {
      bulletColor: '#4B2CE7',
      point: 'Full Stack Developer',
    },

    {
      bulletColor: '#FF6676',
      point: 'Cloud Engineer',
    },

    {
      bulletColor: '#FF8800',
      point: 'DevOps Engineer',
    },
  ];

  return (
    <div className="flex flex-col gap-y-[24px] bg-[#F9FAFB] px-[16px] pt-[40px] pb-[52px] md:gap-y-[32px] md:px-[124px] md:py-[80px]">
      <h2 className="pb-[5px] text-center font-satoshi-bold text-[24px] leading-8 md:pb-[32px] md:text-[36px] md:leading-none">
        Opportunites as a{' '}
        <span className="relative -top-2 text-red underline underline-offset-8">
          {subTitle || 'Data Scientist'}
        </span>
      </h2>

      <div className="grid gap-y-[24px] gap-x-[32px] md:grid-cols-3">
        {cardList.map((item, index) => (
          <ComboCard {...item} key={index} />
        ))}
      </div>

      <div className="grid gap-[32px] md:grid-cols-2">
        <ListingCard
          heading={'In-Demand Roles'}
          bulletList={
            isWeb3Course ? inDemandRoleBulletPointWebDev : inDemandRoleBulletPointDataScience
          }
          imagePath={isWeb3Course ? '/assets/In-Demand Roles.svg' : '/assets/in-demand-roles.svg'}
        />
        <ListingCard heading={'High Demand Across Industries'} dataList={industriesList} />
        <ListingCard
          heading={'Salary Progression'}
          imagePath={
            isWeb3Course ? '/assets/Salary-Yearwise.webp' : '/assets/salary-progression.svg'
          }
          containerStyle="md:col-span-2"
        />
      </div>
    </div>
  );
}

export default Opportunities;

function ComboCard({ point, subPoint, logo }) {
  return (
    <section
      key={point}
      className={
        'grid grid-cols-5 items-start gap-x-[20px] rounded-lg bg-white p-[30px] md:grid-cols-4'
      }
      style={{ boxShadow: '0px 30px 40px 0px rgba(212, 217, 232, 0.05)' }}
    >
      <div className="flex h-[60px] w-[60px] items-center justify-center rounded-full bg-[#F2F4F7]">
        <img src={logo} className="object-contain" />
      </div>
      <div className={'col-span-4 flex flex-col gap-y-[8px] md:col-span-3'}>
        <h3 className="font-satoshi-bold text-[20px] leading-[30px]">{point}</h3>
        <p className="font-satoshi-regular text-[16px] leading-6 text-gray-400">{subPoint}</p>
      </div>
    </section>
  );
}

function ListingCard({ heading, dataList = [], bulletList = [], imagePath, containerStyle = '' }) {
  return (
    <div
      className={`flex flex-col gap-y-[40px] rounded-lg bg-white p-[24px] ${containerStyle}`}
      style={{ boxShadow: '0px 30px 40px 0px rgba(212, 217, 232, 0.05)' }}
    >
      <div className="flex flex-col gap-y-[16px]">
        <h3 className="font-satoshi-bold text-[20px] leading-[30px]">{heading}</h3>
        {bulletList.length > 0 && (
          <div className="flex flex-wrap items-center gap-[16px]">
            {bulletList.map(({ bulletColor, point }) => (
              <span className="flex items-center gap-x-[4px]" key={point}>
                <span
                  className="h-[12px] w-[12px] rounded-sm"
                  style={{ backgroundColor: bulletColor }}
                ></span>
                <p className="font-satoshi-regular text-[16px] leading-6">{point}</p>
              </span>
            ))}
          </div>
        )}
      </div>

      {dataList.length > 0 && (
        <div className="grid grid-cols-3 gap-[32px]">
          {dataList.map(({ logo, point }, index) => (
            <div className="flex flex-col items-center gap-y-[16px]" key={index}>
              <Image
                src={logo}
                objectFit="contain"
                width={64}
                height={64}
                draggable={false}
                loading="lazy"
              />
              <p className="font-satoshi-medium text-[16px] leading-6 text-[#1A1A1A]">{point}</p>
            </div>
          ))}
        </div>
      )}

      {imagePath && (
        <div>
          <img src={imagePath} className="h-full w-full object-contain" draggable={false} />
        </div>
      )}
    </div>
  );
}
